/* eslint-disable */
// WARNING: This file is generated during build from Gen 2 outputs and amplify/runtime-config.json.

const awsmobile = {
  "aws_project_region": "ap-southeast-2",
  "aws_cognito_identity_pool_id": "ap-southeast-2:325ceee9-e38c-47ca-b7d7-94a9e8a0c49f",
  "aws_cognito_region": "ap-southeast-2",
  "aws_user_pools_id": "ap-southeast-2_T2c3ERFmc",
  "aws_user_pools_web_client_id": "p473063lc5lsv8omdd1l1u9uk",
  "oauth": {},
  "aws_cognito_username_attributes": [
    "EMAIL"
  ],
  "aws_cognito_social_providers": [],
  "aws_cognito_signup_attributes": [
    "GIVEN_NAME",
    "FAMILY_NAME",
    "EMAIL",
    "PHONE_NUMBER"
  ],
  "aws_cognito_mfa_configuration": "OFF",
  "aws_cognito_mfa_types": [],
  "aws_cognito_password_protection_settings": {
    "passwordPolicyMinLength": 8,
    "passwordPolicyCharacters": [
      "REQUIRES_LOWERCASE",
      "REQUIRES_UPPERCASE",
      "REQUIRES_NUMBERS",
      "REQUIRES_SYMBOLS"
    ]
  },
  "aws_cognito_verification_mechanisms": [
    "EMAIL"
  ],
  "aws_user_files_s3_bucket": "meadocumentsbucketc37b0f-hdiprdapac",
  "aws_user_files_s3_bucket_region": "ap-southeast-2"
};

export default awsmobile;
